var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isTeamLeague || _vm.isMixedLeague)?_c('AddFlexLeagueScores',{attrs:{"id":_vm.id,"mixed":_vm.isMixedLeague}}):_c('AddTeamLeagueScores',{attrs:{"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }